// import React, { useEffect, useState } from 'react'
// import { NavLink, useNavigate } from 'react-router-dom';
// import Layouts from './layouts/layout';
// import styles from './css/promoLimit.module.css';
// import { getUserPromoLimitStatus, buyPromoQuestions, updatePromoLimit } from '../services/home';
// import { toast } from 'react-toastify';

// // ===================== TEXT (0 = English, 3 = Portuguese) =====================
// const limitText = {
//     "0": {
//         back: "Back to home",
//         title: "Daily limit reached",
//         textStart: "You've played all",
//         textBold: "20 questions",
//         textEnd: "for today.",
//         badge: "Try again tomorrow",
//         sub: "Your stars are safe and still count on the leaderboard.",
//         buy: "Buy More Questions with M-Pesa",
//         buying: "Processing...",
//         buySuccess: "Request sent! Please confirm the payment on your phone with your M-Pesa PIN.",
//         buyError: "Something went wrong. Please try again.",
//         home: "Back to home",
//         leaderboard: "See leaderboard",
//     },
//     "3": {
//         back: "Voltar ao início",
//         title: "Limite diário atingido",
//         textStart: "Já jogaste as",
//         textBold: "20 perguntas",
//         textEnd: "de hoje.",
//         badge: "Tenta novamente amanhã",
//         sub: "Os teus estrelas estão guardados e continuam a contar na classificação.",
//         buy: "Comprar Mais Perguntas com M-Pesa",
//         buying: "A processar...",
//         buySuccess: "Pedido enviado! Confirma o pagamento no teu telemóvel com o teu PIN M-Pesa.",
//         buyError: "Ocorreu um erro. Tenta novamente.",
//         home: "Voltar ao início",
//         leaderboard: "Ver classificação",
//     },
// };

// const PromoLimit = () => {
//     const navigate = useNavigate();
//     const language = localStorage.getItem('selectedLanguage');
//     const text = limitText[language] || limitText["0"];
//     const [buyLoading, setBuyLoading] = useState(false);
//     const [buyStatus, setBuyStatus] = useState(null); // null | "success" | "error"

//     useEffect(() => {
//         getUserPromoLimitStatus()
//             .then((res) => {
//                 navigate("/");
//             })
//             .catch((err) => {
//                 console.error(err);
//                 const message = err?.error || err?.message || err?.data?.error || "";

//                 if (
//                     String(message).toLowerCase().includes("limit") ||
//                     message === "Limit Reached"
//                 ) {
//                     // navigate("/promo/limit");
//                 }
//                 else {
//                     navigate("/");
//                 }
//             });
//     }, []);

//     // ===================== BUY MORE QUESTIONS (M-PESA) =====================
//     const handleBuyMore = () => {
//         if (buyLoading) return;
//         setBuyLoading(true);
//         setBuyStatus(null);

//         buyPromoQuestions()
//             .then((res) => {
//                 updatePromoLimit().then(() => {
//                     setBuyStatus("success");
//                     navigate("/success/topupContest");
//                 }).catch()
//             })
//             .catch((err) => {
//                 console.error(err);
//                 setBuyStatus("error");
//             })
//             .finally(() => {
//                 setBuyLoading(false);
//             });
//     };

//     return (
//         <Layouts>
//             <div className={styles.page}>

//                 {/* HEADER WITH BACK ARROW */}
//                 <div className={styles.header}>
//                     <button type="button" className={styles.backButton} onClick={() => navigate('/home')} aria-label={text.back}>
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                             <polyline points="15 18 9 12 15 6" />
//                         </svg>
//                     </button>
//                 </div>

//                 {/* LIMIT REACHED CARD */}
//                 <div className={styles.card}>
//                     <div className={styles.icon}>⏳</div>
//                     <h2 className={styles.title}>{text.title}</h2>
//                     <p className={styles.text}>
//                         {text.textStart} <strong>{text.textBold}</strong> {text.textEnd}
//                     </p>
//                     <div className={styles.badge}>{text.badge}</div>
//                     <p className={styles.sub}>{text.sub}</p>

//                     {/* BUY MORE QUESTIONS WITH M-PESA */}
//                     <button
//                         type="button"
//                         className={styles.primaryButton}
//                         onClick={handleBuyMore}
//                         disabled={buyLoading}
//                     >
//                         {buyLoading ? (
//                             <>
//                                 <span className={styles.spinner} aria-hidden="true"></span>
//                                 {text.buying}
//                             </>
//                         ) : (
//                             <>💰 {text.buy}</>
//                         )}
//                     </button>

//                     {buyStatus === "success" && (
//                         <p className={`${styles.buyMessage} ${styles.buySuccess}`}>{text.buySuccess}</p>
//                     )}
//                     {buyStatus === "error" && (
//                         <p className={`${styles.buyMessage} ${styles.buyError}`}>{text.buyError}</p>
//                     )}

//                     <button type="button" className={styles.secondaryButton} onClick={() => navigate('/home')}>
//                         {text.home}
//                     </button>
//                     {/* <NavLink to="/promo/leaderboard" className={styles.secondaryButton}>{text.leaderboard}</NavLink> */}
//                 </div>

//             </div>
//         </Layouts>
//     )
// }

// export default PromoLimit




import React, { useEffect, useState, useRef } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import Layouts from './layouts/layout';
import styles from './css/promoLimit.module.css';
import { getUserPromoLimitStatus, buyPromoQuestions, updatePromoLimit } from '../services/home';
import { toast } from 'react-toastify';

// ===================== TEXT (0 = English, 3 = Portuguese) =====================
const limitText = {
    "0": {
        back: "Back to home",
        title: "Daily limit reached",
        textStart: "You've played all",
        textBold: "20 questions",
        textEnd: "for today.",
        badge: "Try again tomorrow",
        sub: "Your stars are safe and still count on the leaderboard.",
        buy: "Buy More Questions with M-Pesa",
        buying: "Processing...",
        buySuccess: "Request sent! Please confirm the payment on your phone with your M-Pesa PIN.",
        buyError: "Something went wrong. Please try again.",
        home: "Back to home",
        leaderboard: "See leaderboard",
    },
    "3": {
        back: "Voltar ao início",
        title: "Limite diário atingido",
        textStart: "Já jogaste as",
        textBold: "20 perguntas",
        textEnd: "de hoje.",
        badge: "Tenta novamente amanhã",
        sub: "Os teus estrelas estão guardados e continuam a contar na classificação.",
        buy: "Comprar Mais Perguntas com M-Pesa",
        buying: "A processar...",
        buySuccess: "Pedido enviado! Confirma o pagamento no teu telemóvel com o teu PIN M-Pesa.",
        buyError: "Ocorreu um erro. Tenta novamente.",
        home: "Voltar ao início",
        leaderboard: "Ver classificação",
    },
};

const PromoLimit = () => {
    const navigate = useNavigate();
    const language = localStorage.getItem('selectedLanguage');
    const text = limitText[language] || limitText["0"];
    const [buyLoading, setBuyLoading] = useState(false);
    const [buyStatus, setBuyStatus] = useState(null); // null | "success" | "error"
    const buyInProgress = useRef(false); // guards against double taps before re-render

    useEffect(() => {
        getUserPromoLimitStatus()
            .then((res) => {
                navigate("/");
            })
            .catch((err) => {
                console.error(err);
                const message = err?.error || err?.message || err?.data?.error || "";

                if (
                    String(message).toLowerCase().includes("limit") ||
                    message === "Limit Reached"
                ) {
                    // navigate("/promo/limit");
                }
                else {
                    navigate("/");
                }
            });
    }, []);

    // ===================== BUY MORE QUESTIONS (M-PESA) =====================
    const handleBuyMore = () => {
        if (buyInProgress.current) return;
        buyInProgress.current = true;
        setBuyLoading(true);
        setBuyStatus(null);

        buyPromoQuestions()
            .then((res) => {
                setBuyStatus("success");
                navigate("/success/topupContest");
            })
            .catch((err) => {
                console.error(err);
                setBuyStatus("error");
            })
            .finally(() => {
                buyInProgress.current = false;
                setBuyLoading(false);
            });
    };

    // ===================== SAFE NAVIGATION (blocked while loading) =====================
    const goHome = () => {
        if (buyLoading) return;
        navigate('/home');
    };

    return (
        <Layouts>
            <div className={styles.page}>

                {/* HEADER WITH BACK ARROW */}
                <div className={styles.header}>
                    <button
                        type="button"
                        className={styles.backButton}
                        onClick={goHome}
                        disabled={buyLoading}
                        aria-label={text.back}
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="15 18 9 12 15 6" />
                        </svg>
                    </button>
                </div>

                {/* LIMIT REACHED CARD */}
                <div className={styles.card}>
                    <div className={styles.icon}>⏳</div>
                    <h2 className={styles.title}>{text.title}</h2>
                    <p className={styles.text}>
                        {text.textStart} <strong>{text.textBold}</strong> {text.textEnd}
                    </p>
                    <div className={styles.badge}>{text.badge}</div>
                    <p className={styles.sub}>{text.sub}</p>

                    {/* BUY MORE QUESTIONS WITH M-PESA */}
                    <button
                        type="button"
                        className={`${styles.primaryButton} ${styles.loadingButton}`}
                        onClick={handleBuyMore}
                        disabled={buyLoading}
                        aria-busy={buyLoading}
                    >
                        {buyLoading ? (
                            <>
                                <span className={styles.spinnerLight} aria-hidden="true"></span>
                                {text.buying}
                            </>
                        ) : (
                            <>💰 {text.buy}</>
                        )}
                    </button>

                    {buyStatus === "error" && (
                        <p className={`${styles.buyMessage} ${styles.buyError}`}>{text.buyError}</p>
                    )}

                    <button
                        type="button"
                        className={styles.secondaryButton}
                        onClick={goHome}
                        disabled={buyLoading}
                    >
                        {text.home}
                    </button>
                    {/* <NavLink to="/promo/leaderboard" className={styles.secondaryButton}>{text.leaderboard}</NavLink> */}
                </div>

            </div>
        </Layouts>
    )
}

export default PromoLimit